const VERIFIER_BYTES = 32;
const STATE_NONCE_BYTES = 16;

const toArrayBuffer = (bytes: Uint8Array): ArrayBuffer => {
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return copy.buffer;
};

const bytesToBinary = (bytes: Uint8Array): string => {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return binary;
};

export const toBase64Url = (bytes: Uint8Array): string => {
  return btoa(bytesToBinary(bytes))
    .replaceAll('+', '-')
    .replaceAll('/', '_')
    .replaceAll('=', '');
};

export const generateUrlSafeRandom = (byteLength: number): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(byteLength));
  return toBase64Url(bytes);
};

export const generateCodeVerifier = (): string => {
  return generateUrlSafeRandom(VERIFIER_BYTES);
};

export const generateNonce = (): string => {
  return generateUrlSafeRandom(STATE_NONCE_BYTES);
};

export const generateState = (): string => {
  return generateUrlSafeRandom(STATE_NONCE_BYTES);
};

export const generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', toArrayBuffer(data));
  return toBase64Url(new Uint8Array(digest));
};
